import React from 'react';
import PdfVerticalStackedBarChart from './charts/PdfVerticalStackedBarChart';
import PdfHeaderComponent from './PdfHeaderComponent';

const ActivityTypesPageComponent = ({ activityTypesData = null, projectData }) => {
  // Get all unique activity types from the data
  const allActivityTypes = React.useMemo(() => {
    const monthly = activityTypesData?.bountyTypeWiseSubmissionCount || [];
    return Array.from(new Set(
      monthly.flatMap(m => (m?.distribution || []).map(d => d?.bountyType))
        .filter(Boolean)
    ));
  }, [activityTypesData]);

  // Transform activity types data for stacked bar chart
  const activityTypesChartData = activityTypesData?.bountyTypeWiseSubmissionCount?.map(m => {
    const row = { name: m?.month };
    
    // Initialize all types to 0
    allActivityTypes.forEach(type => { row[type] = 0; });
    
    // Fill in actual data
    (m?.distribution || []).forEach(d => {
      if (allActivityTypes.includes(d?.bountyType)) {
        row[d.bountyType] = d?.submissionCount || 0;
      }
    });
    
    return row;
  }) || [];

  return (
    <div className="pdf-section pdf-page-break" style={{ display: 'flex', flexDirection: 'column', padding: '20px', height: '100vh' }}>
      <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <h2 className="text-lg font-bold text-gray-900 mb-2">Activity Types</h2>
        <p className="text-xs text-gray-600 mb-3">Distribution of activities by type</p>
        
        {activityTypesChartData.length > 0 && allActivityTypes.length > 0 ? (
          <div className="bg-grayBgNormal p-4 rounded-lg " style={{ flex: 1, minHeight: '980px' }}>
            <PdfVerticalStackedBarChart
              data={activityTypesChartData}
              activityTypes={allActivityTypes}
              colors={['#003C73', '#76C8E8', '#B0EAC0','#FBCF4E','#F6A4A4','#C9B0D5']}
              height={620}
              showLegend={true}
            />
          </div>
        ) : (
          <div className="bg-grayBgNormal p-4 rounded-lg border border-gray-200 text-center text-gray-500" style={{ minHeight: '980px', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="text-xs">No activity types data available</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityTypesPageComponent;
